<template>
  <div>
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" v-if="isApply" class="content-wrapper">
      <div class="content-wrapper">
        <div class="container">
          <article>
            <section class="section white-panel pr0 pt24 pb0">
              <div class="text-center w100p mb24 mt24">
                車検証登録、申込可能期間、メールアドレス登録の☑は、<br>それぞれ登録すると自動でチェックが入ります
              </div>
              <table class="table w100p fs14">
                <tbody>
                  <tr>
                    <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                      <a v-on:click.stop.prevent="optionCarQRPage(nativeData, versionData)">
                        <a href="#" target="_blank" class="color-green2">
                          車検証をアプリに登録する。
                        </a>
                      </a>
                      <label class="pr44">
                        <input type="checkbox" name="" value="" class="checkbox-input1 cannot-be-checkbox"
                          v-model="checkedCar"
                          :disabled="true"
                          >
                        <span class="checkbox-area1 cannot-be-checkbox-area"></span>
                      </label>
                    </td>
                  </tr>
                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    <label class="pr44">
                      登録された車検証が申込可能期間内である。
                      <input type="checkbox" name="" value="" class="checkbox-input1 cannot-be-checkbox"
                        v-model="checkedApplicationPeriod"
                        :disabled="true"
                        >
                      <span class="checkbox-area1 cannot-be-checkbox-area"></span>
                    </label>

                    <ul class="fs12 color-font2 line-height1_7 mt12 pr44">
                      <li>車検満了日の前後1か月の車両が対象となります。<br>例）車検満了日が6月15日の場合、申込み可能期間は5月15日から7月15日となります。</li>
                    </ul>
                  </td>
                  <tr>
                    <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                      <a href="carlifesquare://mypage" target="_blank" class="color-green2" v-on:click="eventTrackMovedMypage()">メールアドレスを登録する。</a>
                      <label class="pr44">
                        <input type="checkbox" name="" value="" class="checkbox-input1 cannot-be-checkbox"
                          v-model="checkedEmail"
                          :disabled="true"
                          >
                        <span class="checkbox-area1 cannot-be-checkbox-area"></span>
                      </label>
                    </td>
                  </tr>

                  <tr>
                    <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                      <a class="color-green2" v-on:click="gmoCardEntry()" v-show="gmoCardEntryLink">お支払情報(クレジットカード)を登録する。</a>

                      <div v-show="!gmoCardEntryLink">
                        お支払情報(クレジットカード)を登録する。
                        <ul class="fs12 color-font2 line-height1_7 mt12 pr44 list-asterisk1">
                          <li>メールアドレス登録が完了すると、お支払情報の登録が可能となります。</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                    こちらの<a v-on:click="toTermsOfService()" class="color-green2">利用規約</a>に同意します。
                    <label class="pr44">
                      <input type="checkbox" name="" value="" class="checkbox-input1"
                        v-model="checkTermsOfUse"
                        @click="changeTermsOfService"
                      >
                      <span class="checkbox-area1"></span>
                    </label>

                    <ul class="fs12 color-font2 line-height1_7 mt12 pr44">
                      <li>本サービスをご利用の場合は、<span style='font-family:"ＭＳゴシック"'>□</span>にチェックを入れてください。</li>
                    </ul>
                  </td>

                  <tr>
                    <td class="bdb-solid-gray1 pb12 pt12 pr2p td-checkbox-right">
                      <p class="fs13 font-weight-bold mt12 mb12">お申込内容</p>

                      <ul class="fs12 color-font2 mt4 pr44 mp-apply-ul">
                        <li>コース名</li>
                        <li>{{ applicationDetails.courceName }}</li>
                      </ul>
                      <ul class="fs12 color-font2 mt4 pr44 mp-apply-ul">
                        <li>SS名</li>
                        <li>{{ applicationDetails.ssName }}</li>
                      </ul>
                      <ul class="fs12 color-font2 mt4 pr44 mp-apply-ul">
                        <li>車両番号<br>（ナンバープレート）</li>
                        <li>{{ applicationDetails.plateNumber }}</li>
                      </ul>
                    </td>
                  </tr>

                </tbody>
              </table>
            </section>

            <div class="section transparent-panel">
              <p class="mb0 text-center error" v-if="this.isShowCheckBoxMessage">すべてにチェックを入れてください。</p>
              <button class="button fs16 mt8 mb16 pd16 radius200" v-bind:disabled="this.applyButton" v-on:click="subscription(carInfo, userInfo, appVersionHeader)">申し込みをする</button>
            </div>

          </article>
        </div>

      </div>
    </div>
    <div v-else-if="isTermsOfService">
      <a id="isTermsOfService" v-on:click="toApply()"></a>
      <MaintenancePackTermsOfServiceV3></MaintenancePackTermsOfServiceV3>
    </div>
    <!-- メンテパックTOP/メンテパック申込画面に戻るボタン -->
    <form name="fm">
      <input id="tsid" type="hidden" name="tsid" v-bind:value="this.nativeData.tsid">
      <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="this.nativeData.popinfoid">
      <input id="otoken" type="hidden" name="otoken" v-bind:value="this.nativeData.otoken">
      <input id="ss_code" type="hidden" name="ss_code" v-bind:value="this.ssCode">
      <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionData.appVersion">
      <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionData.platform">
      <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionData.osVersion">
      <input id="currentState" type="hidden" name="currentState" v-bind:value="this.currentState">
    </form>
  </div>
</template>

<script>
import modal from '@/assets/v3/modal'
import Loading from '@/views/v3/Loading.vue'
import MaintenancePackTermsOfServiceV3 from '@/views/v3/MaintenancePack/TermsOfService.vue'
import ssApi from '@/store/Api/Common/ss'
import car from '@/store/Api/car'
import subscription from '@/store/Api/MaintenancePack/subscription'
import userInfo from '@/store/Api/Common/userInfo'
import gmoCardEntry from '@/store/Api/MaintenancePack/GMO/cardEntryGet'
import { useGmoPageStore } from '@/store/gmoPage'

const IS_APPLY = 'IS_APPLY'
const IS_TERMS_OF_SERVICE = 'IS_TERMS_OF_SERVICE'

export default {
  data () {
    return {
      loading: true,
      currentState: IS_APPLY,
      cardRegistrationDisabled: false,
      checkedCar: false,
      checkedApplicationPeriod: false,
      checkedEmail: false,
      checkTermsOfUse: false,
      applyButton: true,
      isShowCheckBoxMessage: true,
      gmoCardEntryLink: false,
      carInfo: null,
      userInfo: null,
      cardEntryGetRequestBodyParam: {
        authid: '',
        tsid: '',
        popinfo_id: '',
        otoken: '',
        ss_code: ''
      },
      applicationDetails: {
        courceName: null,
        ssName: null,
        plateNumber: null
      }
    }
  },
  methods: {
    toApply () {
      this.currentState = IS_APPLY
      window.scrollTo(0, 0)
    },
    toTermsOfService () {
      this.nativeEVENTSet('MpSubscriptionButton', 'MOVED_MP_RIYOUKIYAKU', 'TAP')
      this.currentState = IS_TERMS_OF_SERVICE
      window.scrollTo(0, 0)
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    setCarInfo (carInfo) {
      this.carInfo = carInfo
    },
    setUserInfo (userInfo) {
      this.userInfo = userInfo
    },
    setSsInfo (ssInfo) {
      this.ssInfo = ssInfo
    },
    setNativeData (nativeData) {
      this.nativeData = nativeData
    },
    setAppVersionData (versionData) {
      this.versionData = versionData
    },
    setAppVersionHeader (appVersion, platform, osVersion) {
      this.appVersionHeader = `${appVersion}/${platform}/${osVersion}`
    },
    eventTrackMovedShakenData () {
      this.nativeEVENTSet('MpSubscriptionButton', 'MOVED_SHAKEN_DATA', 'TAP')
    },
    eventTrackMovedMypage () {
      this.nativeEVENTSet('MpSubscriptionButton', 'MOVED_MYPAGE', 'TAP')
    },
    /**
     * メンテパック申込APIを呼び出し、メンテパックTOP画面に遷移させる関数
     */
    async subscription (carInfo, userInfo, appVersionHeader) {
      this.nativeEVENTSet('MpSubscriptionButton', 'MP_SUBSCRIPTION', 'TAP')
      this.applyButton = true

      const requestBodyParam = []
      requestBodyParam.tsid = this.nativeData.tsid
      requestBodyParam.popinfo_id = this.nativeData.popinfoid
      requestBodyParam.otoken = this.nativeData.otoken
      requestBodyParam.ss_code = this.ssCode
      requestBodyParam.maintenance_pack_course_id = this.$route.query.cource_id
      requestBodyParam.car_id = carInfo.id

      await subscription.post(userInfo.authid, appVersionHeader, requestBodyParam).then(res => {
        this.$router.push({
          name: 'MaintenancePackApplyCompleteV3',
          query: {
            tsid: this.nativeData.tsid,
            popinfoid: this.nativeData.popinfoid,
            otoken: this.nativeData.otoken,
            ss_code: this.ssCode,
            appVersion: this.versionData.appVersion,
            platform: this.versionData.platform,
            osVersion: this.versionData.osVersion
          }
        })
      }).catch(e => {
        console.log('subscription-error')
        console.log(e.message)
        this.openErrorModal('ただいまアクセスが集中している可能性がございます。恐れ入りますが、時間をおいて再度お試しください。')
      })
      this.applyButton = false
    },
    changeTermsOfService (e) {
      if (e.target.checked && this.checkedCar && this.checkedApplicationPeriod && this.checkedEmail) {
        this.applyButton = false
        this.isShowCheckBoxMessage = false
      } else {
        this.applyButton = true
        this.isShowCheckBoxMessage = true
      }
    },
    async gmoCardEntry () {
      // 戻るボタンの出し分け
      this.appDisplayBack(false)
      this.nativeEVENTSet('MpSubscriptionButton', 'MOVED_GMO_EDIT_CREDIT', 'TAP')
      // authid 以外のパラメータをセット
      this.cardEntryGetRequestBodyParam.tsid = this.nativeData.tsid
      this.cardEntryGetRequestBodyParam.popinfo_id = this.nativeData.popinfoid
      this.cardEntryGetRequestBodyParam.otoken = this.nativeData.otoken
      this.cardEntryGetRequestBodyParam.ss_code = this.ssCode
      await gmoCardEntry.post(this.cardEntryGetRequestBodyParam, this.appVersionHeader).then(res => {
        const gmoPage = res.data
        const gmoPageStore = useGmoPageStore()
        gmoPageStore.gmoPage = gmoPage
        this.$router.push({
          name: 'PaymentV3'
        })
      }).catch(e => {
        console.log('gmoCardEntry-error')
        console.log(e.message)
        this.openErrorModal('ただいまアクセスが集中している可能性がございます。恐れ入りますが、時間をおいて再度お試しください。')
      })
    },
    /**
     * 申し込み可能期間かの判定を行う
     * @param {string} expiryOn - 車検満了日
     * @return {boolean} - 申し込み可能期間判定結果
     */
    checkApplicationPeriod (expiryOn) {
      let checkResult = false
      let expiryOnDate = new Date(expiryOn)
      expiryOnDate.setHours(0, 0, 0, 0)
      let nowDate = new Date()
      nowDate.setHours(0, 0, 0, 0)
      // 満了日から1か月前
      const mounth1 = -1
      const targetMonth1 = this.getTargetDate(expiryOnDate, mounth1)
      // 満了日から23か月前
      const experyOnMounth23 = -23
      const experyOnTargetMonth23 = this.getTargetDate(expiryOnDate, experyOnMounth23)
      // 満了日から25か月前
      const experyOnMounth25 = -25
      const experyOnTargetMonth25 = this.getTargetDate(expiryOnDate, experyOnMounth25)

      nowDate = nowDate.getTime()
      expiryOnDate = expiryOnDate.getTime()

      // 現在日が、満了日の1か月前 ～ 満了日当日以内、または、現在日が、満了日の25か月前 ～ 満了日の23か月前以内である
      if ((targetMonth1 <= nowDate && nowDate <= expiryOnDate) || (experyOnTargetMonth25 <= nowDate && nowDate <= experyOnTargetMonth23)) {
        checkResult = true
      }

      return checkResult
    },
    /**
     * 任意の日付（月単位）をミリ秒数で返す関数
     * @param {string} date - 現在の年月日
     * @param {number} targetMonth - 任意の月[満了日から](1か月前[-1], 翌月末[1], 23か月前の月末[-23], 25か月前[-25])
     * @return {number} - 該当する日付のミリ秒
     */
    getTargetDate (date, targetMonth, checkPaymentButton) {
      // 基準の年月日を取得
      const year = date.getFullYear()
      const month = date.getMonth()
      const day = date.getDate()

      // 基準の年月からDateオブジェクトを生成
      const nextDate = new Date(year, month)
      // 月の設定を変更
      nextDate.setMonth(nextDate.getMonth() + targetMonth)
      // 末日を取得
      const lastDay = new Date(nextDate.getFullYear(), nextDate.getMonth() + 1, 0).getDate()

      if (!checkPaymentButton) {
        // 元の日にちが該当月に無い場合はその月の末日を設定する
        if (lastDay < day) {
          nextDate.setDate(lastDay)
        } else {
          nextDate.setDate(day)
        }
      } else {
        nextDate.setDate(lastDay)
      }

      return nextDate.getTime()
    },
    optionCarQRPage (nativeData, versionData) {
      this.eventTrackMovedShakenData()
      this.$router.push({
        name: 'OptionCarQRV3',
        query: {
          tsid: nativeData.tsid,
          popinfo_id: nativeData.popinfoid,
          otoken: nativeData.otoken,
          x_cls_app_version: versionData.appVersion,
          x_cls_os: versionData.platform,
          x_cls_os_version: versionData.osVersion,
          fromApply: true
        }
      })
    }
  },
  computed: {
    nativeData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.tsid = this.$route.query.tsid
      getData.popinfoid = this.$route.query.popinfoid
      getData.otoken = this.$route.query.otoken
      return getData
    },
    ssCode: function () {
      // ネイティブから取得したデータを格納する。
      const getData = this.$route.query.ss_code
      return getData
    },
    versionData: function () {
      const getData = {}
      // ネイティブから取得したデータを格納する。
      getData.appVersion = this.$route.query.appVersion
      getData.platform = this.$route.query.platform
      getData.osVersion = this.$route.query.osVersion
      return getData
    },
    isApply () {
      return this.currentState === IS_APPLY
    },
    isTermsOfService () {
      return this.currentState === IS_TERMS_OF_SERVICE
    }
  },
  async mounted () {
    this.$loadScript('https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js')
    this.$loadScript('/lib/js/main.js')

    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    let isApiError = false

    this.applicationDetails.courceName = this.$route.query.cource_name

    this.setAppVersionHeader(this.$route.query.appVersion, this.$route.query.platform, this.$route.query.osVersion)

    // 車検証情報取得
    await car.get(this.nativeData.tsid).then(res => {
      this.setCarInfo(res.data.car[0])
      if (this.carInfo) {
        // QRでの車検証登録済みであれば車検証チェックボックスONに切り替える
        if (this.carInfo.qr) {
          this.applicationDetails.plateNumber = this.carInfo.plate_number
          this.checkedCar = true
          // 申し込み可能期間であれば申込可能期間チェックボックスONに切り替える
          if (this.checkApplicationPeriod(this.carInfo.expiry_on)) {
            this.checkedApplicationPeriod = true
          }
        }
      }
    }).catch(e => {
      console.log('car-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // ユーザー情報取得
    await userInfo.get(this.nativeData, this.appVersionHeader).then(res => {
      this.setUserInfo(res.data.body.id)
      if (this.userInfo) {
        this.cardEntryGetRequestBodyParam.authid = this.userInfo.authid
        // ログイン済みユーザーであればメールアドレス登録チェックボックスONに切り替える
        if (this.userInfo.authid) {
          this.checkedEmail = true
          this.gmoCardEntryLink = true
        }
      }
    }).catch(e => {
      console.log('userInfo-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    // SS情報取得
    await ssApi.get(this.ssCode).then(res => {
      this.setSsInfo(res.data.body.ss_info)
      if (this.ssInfo) {
        this.applicationDetails.ssName = this.ssInfo.ss_name
      }
    }).catch(e => {
      console.log('ss-error')
      console.log(e.message)
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    if (!isApiError) {
      this.loading = false
    }

    this.nativePVset('MpSubscription')
  },
  components: {
    Loading,
    MaintenancePackTermsOfServiceV3
  }
}

</script>
